import { Component } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent {
  pageTitle: any = '';

  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    this.navService.titleSub.subscribe(res => {
      // console.log(res);
      this.pageTitle = res;
    })
  }
}
